import { render, staticRenderFns } from "./ExpressSettings.vue?vue&type=template&id=c3d846d2&scoped=true&"
import script from "./ExpressSettings.vue?vue&type=script&lang=js&"
export * from "./ExpressSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d846d2",
  null
  
)

export default component.exports